<template>
  <page>
                <v-expansion-panels v-model="panel1" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Date Range
              </div>
            </v-expansion-panel-header>
              <v-expansion-panel-content>
    <v-card>
      <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <cal-picker
                  v-model="form.fromDate"
                  :label="labels.fromDate"
                  v-validate="fromDateValidation"
                  :data-vv-as="labels.fromDate"
                  data-vv-name="fromDate"
                  :error-messages="errors.collect('fromDate')"
                  :max="form.today"
                ></cal-picker>
              </v-flex>
              <v-flex xs12 md6>
                <cal-picker
                  v-model="form.toDate"
                  :label="labels.toDate"
                  v-validate="toDateValidation"
                  :data-vv-as="labels.toDate"
                  data-vv-name="toDate"
                  :error-messages="errors.collect('toDate')"
                  :min="form.fromDate"
                  :max="form.today"
                ></cal-picker>
              </v-flex>
            </v-layout>
            </v-container>
            </v-card-text>
            </v-card>
                        </v-expansion-panel-content>
          </v-expansion-panel>
          </v-expansion-panels>
          <v-spacer class="mt-2"></v-spacer>
                <v-expansion-panels v-model="panel1" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Selection Criteria
              </div>
            </v-expansion-panel-header>
              <v-expansion-panel-content>
    <v-card>
      <v-card-text>
        <form>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <!-- Direct/RI/Both -->
                <v-autocomplete
                  :label="labels.dri"
                  :items="driList"
                  v-model="form.dri"
                  item-text="value"
                  item-value="code"
                  data-vv-name="dri"
                  :data-vv-as="labels.dri"
                  :error-messages="errors.collect('dri')"
                  v-validate="'required'"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex xs12 md6>
                <!-- Branch -->
                <v-text-field
                  v-model="form.branch"
                  :label="labels.branch"
                  :error-messages="errors.collect('branch')"
                  :data-vv-as="labels.branch"
                  data-vv-name="branch"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('branch')"
                  readonly
                  v-validate="'required'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <!-- <v-flex xs12 md6>
                <v-text-field
                  v-model="form.fund"
                  :label="labels.fund"
                  :error-messages="errors.collect('fund')"
                  :data-vv-as="labels.fund"
                  data-vv-name="fund"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('fund')"
                  readonly
                  v-validate="'required'"
                ></v-text-field>
              </v-flex> -->
              <v-flex xs12 md6>
                <!-- Business Class -->
                <v-text-field
                  v-model="form.busCls"
                  :label="labels.busCls"
                  :error-messages="errors.collect('busCls')"
                  :data-vv-as="labels.busCls"
                  data-vv-name="busCls"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('busCls')"
                  readonly
                  v-validate="'required'"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <!-- RI Type -->
                <v-autocomplete
                  :label="labels.riType"
                  :items="riTypeList"
                  v-model="form.riType"
                  item-text="value"
                  item-value="code"
                  data-vv-name="riType"
                  :data-vv-as="labels.riType"
                  :error-messages="errors.collect('riType')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <!-- Treaty Code -->
                <v-text-field
                  v-model="form.inter"
                  :label="labels.inter"
                  :error-messages="errors.collect('inter')"
                  :data-vv-as="labels.inter"
                  :disabled='riTypeIsForD'
                  data-vv-name="inter"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('inter')"
                  readonly
                  v-validate="'required'"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card-text>
    </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          </v-expansion-panels>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-checkbox v-model="form.prtRptRunTime" :label="labels.prtRptRunTime" data-vv-name="prtRptRunTime"
            :data-vv-as="labels.prtRptRunTime" />
          <!-- <v-btn class="mr-2" color="info" :loading="submitting" @click.prevent="doSchedule">
            <v-icon left dark>mdi-clock</v-icon>
            {{ labels.schedule }}
          </v-btn> -->
          <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
            {{ labels.export }}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="form.format">
            <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
              <span>{{ format.label }}</span>
              <v-icon :color="format.color">{{ format.icon }}</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="multiFundList" width="900px" persistent>
      <multi-fund-help-list :fnd="form.fund" @close="multiFundList = false" @doAssign="doAssignMulti($event)"></multi-fund-help-list>
    </v-dialog>

    <v-dialog v-model="multiBusClsList" width="900px" persistent>
      <multi-bus-cls-help-list :busCls="form.busCls" @close="multiBusClsList = false" @doAssign="doAssignMulti($event)"></multi-bus-cls-help-list>
    </v-dialog>

    <v-dialog v-model="multiBranchList" width="900px" persistent>
      <multi-branch-help-list :brn="form.branch" @close="multiBranchList = false" @doAssign="doAssignMulti($event)"></multi-branch-help-list>
    </v-dialog>

    <v-dialog v-model="multiInterList" width="900px" persistent>
      <multi-treaty-ref-no-help-list
        v-if="multiInterList"
        :ttyrefno="form.inter"
        :ritype="form.riType"
        @close="multiInterList = false"
        @doAssign="doAssignMulti($event)"
      ></multi-treaty-ref-no-help-list>
    </v-dialog>

    <v-dialog v-model="scheduleJobModal" width="1000px" persistent>
      <ScheduleJob @close="scheduleJobModal = false" :jobName="jobName" :jobDesc="jobDesc"></ScheduleJob>
    </v-dialog>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList.vue'
import MultiBusClsHelpList from '@/components/core/common/dialog/MultiBusClsHelpList.vue'
import MultiFundHelpList from '@/components/core/common/dialog/MultiFundHelpList.vue'
import MultiTreatyRefNoHelpList from '@/components/core/common/dialog/MultiTreatyRefNoHelpList.vue'
import ScheduleJob from '@/components/core/common/dialog/ScheduleJob'

export default {
  data() {
    return {
      labels: {
        fromDate: 'Transaction Date From*',
        toDate: 'Transaction Date To*',
        dri: 'Direct/RI',
        branch: 'Branch',
        fund: 'Fund',
        busCls: 'Business Class',
        riType: 'RI Type',
        inter: 'Treaty Code',
        prtRptRunTime: 'Print Runtime Parameters',
        format: 'Export Format',
        export: 'Export to',
        schedule: 'Schedule'
      },
      form: {
        fromDate: null,
        toDate: null,
        dri: 'D',
        branch: 'All',
        fund: 'All',
        busCls: 'All',
        riType: 'All',
        inter: 'All',
        prtRptRunTime: true,
        format: 'PDF',
        today: new Date()
      },
      menu: {},
      supportedFormat: [],
      submitting: false,
      driList: [
        { code: 'D', value: 'Direct' },
        { code: 'R', value: 'Reinsurance Inwards' },
        { code: 'B', value: 'Both' }
      ],
      riTypeList: [
        { code: 'All', value: 'All' },
        { code: 'F', value: 'F - Fac' },
        { code: 'T', value: 'T - Treaty' },
        { code: 'D', value: 'D - Stat' },
        { code: 'W', value: 'W - Quota' }
      ],
      mode: '',
      multiBranchList: false,
      multiFundList: false,
      multiBusClsList: false,
      multiInterList: false,
      scheduleJobModal: false,
      jobName: 'qrtzVoluntaryCessions',
      jobDesc: 'Voluntary Cessions',
      panel1: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.accountReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    riTypeIsForD() {
      return this.form.riType === 'D' || this.form.riType === 'F'
    },
    fromDateValidation() {
      if (this.form.fromDate !== '' && this.form.fromDate !== null && this.form.fromDate !== undefined) {
        return 'entry|valTranDateFrom:' + this.form.toDate
      } else {
        return 'required'
      }
    },
    toDateValidation() {
      if (this.form.toDate !== '' && this.form.toDate !== null && this.form.toDate !== undefined) {
        return 'entry|valTranDateTo:' + this.form.fromDate
      } else {
        return 'required'
      }
    }
  },
  watch: {
    supportedList: function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.form.format = value[0].value
      }
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.accountReports.init !== 1) {
          await this.$store.dispatch('accountReportsInit')
        }
        const apiURI = this.rptMenu.volCessions
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    getHelpList(fieldName) {
      this.mode = fieldName
      switch (fieldName) {
        case 'branch':
          this.multiBranchList = true
          break
        case 'fund':
          this.multiFundList = true
          break
        case 'busCls':
          this.multiBusClsList = true
          break
        case 'inter':
          this.multiInterList = true
          break
      }
    },
    async doAssignMulti(Obj) {
      switch (this.mode) {
        case 'branch':
          this.form.branch = []
          this.form.branch = Obj.finalSelectedItems.toString()
          break
        case 'fund':
          this.form.fund = []
          this.form.fund = Obj.finalSelectedItems.toString()
          break
        case 'busCls':
          this.form.busCls = []
          this.form.busCls = Obj.finalSelectedItems.toString()
          break
        case 'inter':
          this.form.inter = []
          this.form.inter = Obj.finalSelectedItems.toString()
          break
      }
    },
    doSchedule() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.scheduleJob()
        }
      })
    },
    scheduleJob() {
      this.scheduleJobModal = true
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.exportVolCess
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.form)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  created() {
    this.doInit()

    this.$validator.extend('valTranDateFrom', {
      getMessage(field, args) {
        return 'Must be same date or earlier date than To Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var fromDate = args[0]
        if (fromDate) {
          return !isAfter(removeTime(value), removeTime(fromDate))
        }
      }
    })

    this.$validator.extend('valTranDateTo', {
      getMessage(field, args) {
        return 'To Date must be greater or equal to From Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var toDate = args[0]
        if (toDate) {
          return !isAfter(removeTime(toDate), removeTime(value))
        }
      }
    })
  },
  mixins: [MessageMixin],
  components: {
    MultiFundHelpList,
    MultiBusClsHelpList,
    MultiBranchHelpList,
    MultiTreatyRefNoHelpList,
    ScheduleJob
  }
}
</script>
